var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label font-weight-bold label-lg label-inline",class:{
    'label-light-warning': _vm.merchantId === 1,
    'label-light-success': _vm.merchantId === 2,
  },staticStyle:{"width":"max-content"}},[_vm._v(_vm._s(_vm.getMerchantName(_vm.merchantId)))])
}
var staticRenderFns = []

export { render, staticRenderFns }